module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/inverstor-1f65ff38e4d8a7ac00fd1849032b5fce.png";